import React from 'react';
import { s } from '../styles';
import { BulletCard, Callout } from '../atoms';
import { IconShield, IconRelax, IconPush } from '../icons';

// Screen 3 — Movements. Safety callout (with a path-B-specific extra
// line for users on the release-first track) + 3 bullets covering the
// squeeze / relax / push verbs.
export function Content({ t, userPath }) {
  return (
    <div className="screen-enter">
      <h1 style={s.title} className="screen-enter-child">{t('fl_movements_title')}</h1>
      <div className="screen-enter-child">
        <Callout
          extra={userPath === 'B' ? t('fl_safety_path_b_extra') : null}
        >
          {t('fl_safety_callout')}
        </Callout>
      </div>
      <div style={s.bulletStack} className="screen-enter-child">
        <BulletCard icon={<IconShield />} className="stagger-item" style={{ '--stagger-i': 0 }}>
          {t('fl_movements_squeeze_label')}: {t('fl_movements_squeeze_desc')}
        </BulletCard>
        <BulletCard icon={<IconRelax />} className="stagger-item" style={{ '--stagger-i': 1 }}>
          {t('fl_movements_relax_label')}: {t('fl_movements_relax_desc')}
        </BulletCard>
        <BulletCard icon={<IconPush />} className="stagger-item" style={{ '--stagger-i': 2 }}>
          {t('fl_movements_push_label')}: {t('fl_movements_push_desc')}
        </BulletCard>
      </div>
    </div>
  );
}

// Path-B switch: a secondary link offers users with pelvic pain the
// release-first track. The orchestrator (handleSecondaryLink) writes
// path=B to user_progress and dismisses the lesson.
export function Footer({ t, onNext, onSecondaryLink, onBack }) {
  return (
    <>
      <button type="button" style={{ ...s.cta, ...s.ctaEnabled }} onClick={onNext}>
        {t('fl_safety_primary')}
      </button>
      <button type="button" style={s.linkButton} onClick={onSecondaryLink}>
        {t('fl_safety_secondary_link')}
      </button>
      <button type="button" style={s.backButton} onClick={onBack}>
        {t('fl_back')}
      </button>
    </>
  );
}
